module.exports = __webpack_public_path__ + "img/skilled_service.fd3650c8.svg";